<template lang="pug">
el-select.miniStyle(v-model='mapdata' placeholder='请选择' size='mini' @change='openMap' class="miniMap")
  el-option(v-for='item in mapList' :key='item.id' :label='item.name' :value='item.elevation')
</template>

<script>
import mongeApiMlib from "@/CommonDP/mongeView/mongeApiMlib";
import { mongeMutations } from "@/CommonDP/mongeView/store/mongeStore";
export default {
  data () {
    return {
      mapdata: ''
    };
  },
  computed: {
    mapList() {
      return mongeApiMlib.getLevels();
    }
  },
  mounted () {
    this.init();
  },
  methods: {
    init() {
      this.mapdata = this.mapList[0].elevation;
      mongeMutations.changeShowApp(false);
      this.openMini(this.mapdata);
    },
    openMap() {
      this.openMini(this.mapdata);
    },
    openMini(val) {
      mongeApiMlib.changeMiniH5(val, false, {
        callback: (type) => {
          if (type === 3) {
            mongeMutations.changeShowApp(true);
            this.$emit("closeCom", 'minimapH5', false);
          }
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.miniMap{
  position: fixed;
  top: 194px;
  left: 0px;
  z-index: 4;
  /deep/.el-input__inner{
    border-color:transparent!important;
    // color: #fff;
    // background: rgba(0, 0, 0, 0.5);
    box-shadow: rgba(0, 0, 0, 0.7) 2px -2px 1px 0px
  }
}
.miniStyle{
  width: 202px;
  border-radius: 0 0px 10px 0;
  overflow: hidden;
}

</style>
